module.exports = __webpack_public_path__ + "static/media/star-and-crescent.7abbbb3a.svg";